import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const CALENDAR_IDS_SUCCESS = "CALENDAR_IDS_SUCCESS";
export const CALENDAR_IDS_ERROR = "CALENDAR_IDS_ERROR";

// Thunk Action Creator
export const getCalendarIdsAction = createAsyncThunk(
    "api/Calendar/getCalendarIds",
    async (json, { dispatch }) => {

        try {
        const response = await axios.post(
            `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/getCalendarIds`,
            {
                AccessToken: json.accessToken,
                Type: json.provider
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )

            if (response.status === 200) {
                if (response.data === '') {
                    throw new Error("Problem getting calendar ids events. Logging the user out");
                } else {
                    dispatch({
                        type: CALENDAR_IDS_SUCCESS,
                        payload: response.data,
                    });
                }
            }
        }
        catch (error) {
            dispatch({ type: CALENDAR_IDS_ERROR, payload: error });
            await signOut();
        }
    }
);
